import React, { useEffect, useRef, useState } from "react";
import Pagination from "react-js-pagination";
import ConfigDB from "../../config";
import { useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  Button,
  Form,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";

import Select from "react-select";
import {
  WareHouseEntitySerach,
  WareHouseSerachList,
  WareHouseTypeSerachList,
  createWareHouse,
  deleteWareHouse,
  getWareHouseList,
  updateWareHouse,
} from "../../services/WareHouseServices";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Barcode from "react-barcode";
import ReactPaginate from "react-paginate";
import { QRCodeCanvas } from "qrcode.react";

const WareHouseMain = () => {
  const tableLengthList = ConfigDB.data.dataTableLength;
  const { t } = useTranslation();
  const location = useLocation();

  const [params, setParams] = useState({
    limit: tableLengthList[0],
    page: 1,
    search: "",
    is_reload: false,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [wareHouseList, setWareHouseList] = useState([]);

  const [delModal, setDelModal] = useState(false);
  const [isDelButtonLoad, setIsDelButtonLoad] = useState(false);
  const [delpart, setDelPart] = useState("");
  const [modifyModal, setModifyModal] = useState(false);
  const [isModifyButtonLoad, setIsModifyButtonLoad] = useState(false);
  const [wareHouseEntityData, setWareHouseEntityData] = useState({
    id: "",
    uuid: "",
    entity_type_id: "",
    warehouse_name: "",
    parent_id: "",
    warhouse_type_id: "",
  });

  let errorsObj = {
    warehouse_name: "",
    entity_type_id: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const [entityList, setEntityList] = useState([]);
  const [parentList, setParentList] = useState([]);

  const [modifyBarcodeModal, setModifyBarcodeModal] = useState(false);
  const [BarcodeData, setBarcodeData] = useState("");
  const [wareHouseSerachList, setWareHouseSerachList] = useState([]);

  const [partLocationDetails, setPartLocationDetails] = useState("");

  const [selectedEntityId, setSelectedEntityId] = useState("");

  const handleSelectChange = (event) => {
    const value = event.target.value;

    setSelectedEntityId(value);

    const findItemById = (nodes, id) => {
      for (let node of nodes) {
        if (node.id === id) return node;
        if (node.children) {
          const found = findItemById(node.children, id);
          if (found) return found;
        }
      }
      return null;
    };

    const selectedItem = findItemById(parentList, value);
    setPartLocationDetails(selectedItem);
  };

  const printRef = useRef();
  const qrRef = useRef(null);

  const printQRCode = () => {
    if (!qrRef.current) return;

    // Convert canvas to image
    const canvas = qrRef.current.querySelector("canvas");
    const imgData = canvas.toDataURL("image/png");

    const win = window.open("", "_blank");
    win.document.open();
    win.document.write(`
      <html>
        <head>
          <title>Print QR Code</title>
          <style>
            body { text-align: center; font-family: Arial; margin-top: 50px; }
            img { margin-bottom: 20px; }
            p { font-size: 18px; font-weight: 600; margin-top: 10px; }
          </style>
        </head>
        <body>
          <img src="${imgData}" alt="QR Code" />
          ${BarcodeData?.warehouse_full_path ? `<p>${BarcodeData.warehouse_full_path}</p>` : ""}
          <script>
            window.onload = function() {
              window.print();
              setTimeout(() => window.close(), 500);
            }
          </script>
        </body>
      </html>
    `);
    win.document.close();
  };
  const handleBarcodeClose = () => {
    setModifyBarcodeModal(false);
  };

  const handleBarcodeOpen = (e, item) => {
    setBarcodeData(item);
    setModifyBarcodeModal(true);
  };

  const handleAddModal = () => {
    setModifyModal(true);
    setSelectedEntityId("");
  };

  const handleCloseModal = () => {
    setModifyModal(false);
    setWareHouseEntityData("");
    setErrors({
      warehouse_name: "",
      entity_type_id: "",
    });
  };

  useEffect(() => {
    const currentPath = location.pathname;
    const savedPath = localStorage.getItem("lastVisitedPath");

    if (savedPath && savedPath !== currentPath) {
      localStorage.removeItem("lastVisitedPage");
      localStorage.removeItem("searchValue");
    }

    localStorage.setItem("lastVisitedPath", currentPath);

    const savedPage = localStorage.getItem("lastVisitedPage");
    const storedSearch = localStorage.getItem("searchValue") || "";

    setParams((prevParams) => ({
      ...prevParams,
      search: storedSearch,
      page: savedPage ? parseInt(savedPage, 10) : 1,
    }));
  }, [location.pathname]);

  const handleParams = (e, type) => {
    let paramsObj = { ...params };
    if (type === "length") {
      paramsObj.limit = e.target.value;
    } else if (type === "search") {
      paramsObj.page = 1;
      paramsObj.search = e.target.value;
      localStorage.setItem("searchValue", e.target.value);
      localStorage.removeItem("lastVisitedPage");
    } else if (type === "pagination") {
      paramsObj.page = e.selected + 1;
      localStorage.setItem("lastVisitedPage", e.selected + 1);
    }
    setParams(paramsObj);
  };

  useEffect(function () {
    WareHouseTypeSerachList()
      .then((response) => {
        response = response.data;
        let list = [];
        for (let i = 0; i < response.data.length; i++) {
          list.push({
            value: response.data[i].id,
            label: response.data[i].name,
          });
        }

        setWareHouseSerachList(list);
        toast.success(response.data.message);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
        setWareHouseSerachList([]);
      });
  }, []);

  useEffect(
    function () {
      if (wareHouseEntityData?.warhouse_type_id) {
        let data = {
          limit: 20,
          page: 1,
          search: "",
          warhouse_type_id: wareHouseEntityData?.warhouse_type_id,
        };
        WareHouseEntitySerach(data)
          .then((response) => {
            response = response.data;
            let list = [];
            for (let i = 0; i < response.data.length; i++) {
              list.push({
                value: response.data[i].id,
                label: response.data[i].entity_name,
              });
            }

            setEntityList(list);
          })
          .catch((err) => {});
      }
    },
    [wareHouseEntityData]
  );

  useEffect(() => {
    let data = {
      limit: 20,
      page: 1,
      search: "",
      id: 0,
    };
    WareHouseSerachList(data)
      .then((response) => {
        setParentList(response.data.data);
      })
      .catch((err) => {
        toast.error(err.message);
      });
  }, []);

  const fetchWareHouse = () => {
    let data = { ...params };
    getWareHouseList(data)
      .then((response) => {
        setWareHouseList(response.data.data);
        setTotalRecords(response.data.total);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      });
  };

  useEffect(
    function () {
      let data = { ...params };

      fetchWareHouse(data);
    },
    [params]
  );

  const onDeleteModalClose = () => {
    setDelModal(false);
  };

  const onEditPartGroup = (e, item) => {
    setModifyModal(true);
    setWareHouseEntityData({
      id: item?.id,
      uuid: item?.uuid,
      entity_type_id: item?.entity_type_id,
      warehouse_name: item?.warehouse_name,
      warhouse_type_id: item?.warhouse_type_id,
      parent_id: item?.parent_id,
    });
    setSelectedEntityId(item?.parent_id);
    setErrors({
      warehouse_name: "",
      entity_type_id: "",
    });
  };

  const onDeleteModalOpen = (e, item) => {
    e.preventDefault();
    setDelPart(item.id);
    setDelModal(true);
  };

  const onDestroyPartType = (e) => {
    e.preventDefault();
    setIsDelButtonLoad(true);
    let data = { id: delpart };
    deleteWareHouse(data)
      .then((response) => {
        let data = { ...params };

        fetchWareHouse(data);
        toast.success(response.data.message);
        setDelPart("");
        setDelModal(false);
        setIsDelButtonLoad(false);
      })
      .catch((err) => {
        setIsDelButtonLoad(false);
        toast.error(Utils.getErrorMessage(err));
      });
  };

  const handleWarehoueEntity = (e) => {
    e.preventDefault();
    let error = false;
    let errorObj = { ...errorsObj };
    // if (!wareHouseEntityData.entity_type_id) {
    //   errorObj.entity_type_id = `Entity type  required.`;
    //   error = true;
    // }

    if (!wareHouseEntityData.warehouse_name) {
      errorObj.warehouse_name = `Warehouse name required.`;
      error = true;
    }

    setErrors(errorObj);
    Utils.focusError();

    if (error) return;

    setIsModifyButtonLoad(true);
    let data = {
      warehouse_name: wareHouseEntityData.warehouse_name,
      entity_type_id: 0,
      parent_id: selectedEntityId,
      warhouse_type_id: 0,
    };

    let updateData = {
      uuid: wareHouseEntityData?.uuid,
      warehouse_name: wareHouseEntityData.warehouse_name,
      entity_type_id: 0,
      parent_id: selectedEntityId,
      warhouse_type_id: 0,
    };

    if (wareHouseEntityData?.uuid) {
      updateWareHouse(updateData)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchWareHouse(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWareHouseEntityData({
            id: "",
            uuid: "",
            entity_type_id: "",
            warehouse_name: "",
            parent_id: "",
          });
          setSelectedEntityId("");

          let datas = {
            limit: 10,
            page: 1,
            search: "",
            id: 0,
          };
          WareHouseSerachList(datas)
            .then((response) => {
              setParentList(response.data.data);
            })
            .catch((err) => {
              toast.error(err.message);
            });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    } else {
      createWareHouse(data)
        .then((response) => {
          toast.success(response.data.message);
          let data = { ...params };
          fetchWareHouse(data);
          setModifyModal(false);
          setIsModifyButtonLoad(false);
          setWareHouseEntityData({
            id: "",
            uuid: "",
            entity_type_id: "",
            warehouse_name: "",
            parent_id: "",
          });
          setSelectedEntityId("");

          let datas = {
            limit: 10,
            page: 1,
            search: "",
            id: 0,
          };
          WareHouseSerachList(datas)
            .then((response) => {
              setParentList(response.data.data);
            })
            .catch((err) => {
              toast.error(err.message);
            });
        })
        .catch((err) => {
          toast.error(Utils.getErrorMessage(err));
          setIsModifyButtonLoad(false);
        });
    }
  };
  const renderOptions = (nodes, level = 0) => {
    return nodes?.map((node) => (
      <React.Fragment key={node.id}>
        <option
          value={node.id}
          style={{ fontWeight: node.children?.length ? "bold" : "normal" }}
        >
          {"\u00A0\u00A0".repeat(level) + node.warehouse_name}
        </option>
        {node.children?.length > 0 && renderOptions(node.children, level + 1)}
      </React.Fragment>
    ));
  };

  return (
    <div>
      <div>
        <section className="content-header">
          <div className="container-fluid ">
            {/* Convention banner — labels use the first hierarchy level as
                the "warehouse" and the editor template has a "sem armazém"
                location variant that skips it, so it only makes sense if
                this rule is followed consistently. */}
            <div
              style={{
                background: "#FFF7ED",
                border: "1px solid #FDBA74",
                borderRadius: 10,
                padding: "10px 14px",
                margin: "6px 0 16px",
                display: "flex",
                alignItems: "center",
                gap: 10,
                fontSize: 13.5,
                color: "#9A3412",
              }}
            >
              <i
                className="bi bi-info-circle-fill"
                style={{ color: "#F59E0B", fontSize: 18 }}
              />
              <span>
                <strong>Convenção:</strong> a primeira hierarquia deve ser
                sempre o <strong>nome do armazém</strong> (ex: "Armazém
                Principal"). A seguir, organiza livremente (corredores,
                prateleiras, etc.). Os templates de etiquetas usam esta
                convenção para a variante "Localização sem armazém".
              </span>
            </div>
            <div className="row mb-2">
              <div className="col-sm-6"></div>
              <div className="col-sm-6"></div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card fuelCard container-custom-height">
                  <div className="card-header">
                    <div
                      className="card-title m-0 float-left"
                      style={{ width: "50%" }}
                    >
                      <input
                        type="text"
                        className="form-control"
                        value={params.search}
                        onChange={(e) => handleParams(e, "search")}
                        placeholder={t("search")}
                      ></input>
                    </div>
                    <div className="card-title m-0 float-right d-flex">
                      <button
                        type="button"
                        className="btn  btn-icon-text mr-2"
                        onClick={handleAddModal}
                      >
                        <i className="bi bi-plus-lg"></i>
                        <span className="ms-2">{t("Add")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="vehicleThBg table-responsive table-responsive-vehicle">
                      <table className="table table-bordered rounded-table table table-striped table-hover">
                        <thead>
                          <tr>
                            {/* <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              WareHouse Type Name
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              Entity Name
                            </th> */}
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ width: "10%" }}
                            >
                              WareHouse Name
                            </th>
                            <th
                              className="col-form-label ml-2 Label-my form-label form-label"
                              style={{ textAlign: "center", width: "0%" }}
                            >
                              {t("action")}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {wareHouseList?.map((item, index) => {
                            return (
                              <>
                                <tr>
                                  {/* <td>{item?.warehouse_type_name}</td>
                                  <td>
                                    <div>{item.entity_name}</div>
                                  </td> */}
                                  <td>
                                    <div>{item.warehouse_name}</div>
                                  </td>

                                  <td className="d-flex">
                                    <Dropdown
                                      className="iconDropdown"
                                      onToggle={(isOpen) => {
                                        if (isOpen) {
                                          // This logic runs when the dropdown is opened
                                          const tableResponsive =
                                            document.querySelector(
                                              ".table-responsive"
                                            );
                                          if (tableResponsive) {
                                            tableResponsive.style.overflowX =
                                              "inherit !important";
                                            tableResponsive.style.overflowY =
                                              "inherit !important";
                                          }
                                        }
                                      }}
                                    >
                                      <Dropdown.Toggle
                                        variant="success"
                                        id="dropdown-basic"
                                        className="iconToggle"
                                      >
                                        <i className="bi bi-three-dots-vertical"></i>
                                      </Dropdown.Toggle>

                                      <Dropdown.Menu>
                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onEditPartGroup(e, item)
                                          }
                                        >
                                          <div className="edit-btn">
                                            <i className="bi bi-pencil"></i>
                                          </div>

                                          <span>{t("edit")}</span>
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            onDeleteModalOpen(e, item)
                                          }
                                        >
                                          <div className="trash-btn delete-btn">
                                            <i className="bi bi-trash3"></i>
                                          </div>

                                          <span>{t("delete")}</span>
                                        </Dropdown.Item>

                                        <Dropdown.Item
                                          className="d-flex"
                                          onClick={(e) =>
                                            handleBarcodeOpen(e, item)
                                          }
                                        >
                                          <div className="edit-btn">
                                            <i className="bi bi-upc-scan"></i>
                                          </div>

                                          <span>View Barcode</span>
                                        </Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  </td>
                                </tr>
                              </>
                            );
                          })}
                        </tbody>
                        {wareHouseList && wareHouseList?.length === 0 && (
                          <tr>
                            <td colSpan={7} className={`text-center`}>
                              {" "}
                              {t("no_record_found")}
                            </td>
                          </tr>
                        )}
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                </div>
              </div>
            </div>
          </div>
          <div className="fuelCF">
            <div className="card-footer clearfix card-footer-part ">
              <div className="pagination pagination-sm m-0 float-right">
                <ReactPaginate
                  previousLabel={<i className="bi bi-chevron-double-left"></i>}
                  nextLabel={<i className="bi bi-chevron-double-right"></i>}
                  breakLabel={"..."}
                  pageCount={Math.ceil(totalRecords / params.limit)}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={5}
                  onPageChange={(e) => handleParams(e, "pagination")}
                  forcePage={params.page - 1}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      <Modal isOpen={delModal}>
        <ModalHeader>{`Delete WareHouse`}</ModalHeader>
        <ModalBody>
          <p
            className={`mb-0`}
          >{`Are you sure you want to delete this WareHouse?`}</p>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            disabled={isDelButtonLoad}
            onClick={onDeleteModalClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          {!isDelButtonLoad && (
            <button
              type="button"
              className="btn btn-block bg-red"
              style={{ width: "100px" }}
              onClick={onDestroyPartType}
            >{t("delete")}<i className="bi bi-trash3"></i>
            </button>
          )}
          {isDelButtonLoad && (
            <button
              color="secondary"
              type={`button`}
              disabled={true}
              className={`btn-square`}
            >
              <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
            </button>
          )}
        </ModalFooter>
      </Modal>

      <Modal isOpen={modifyModal}>
        <ModalHeader>Warehouse</ModalHeader>
        <Form method={`post`} onSubmit={handleWarehoueEntity}>
          <ModalBody>
            <div className="row">
              <div className="col-md-12" style={{ display: "none" }}>
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"WareHouse Type"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        options={wareHouseSerachList}
                        value={wareHouseSerachList.find(
                          (option) =>
                            option.value ===
                            Number(wareHouseEntityData.warhouse_type_id)
                        )}
                        onChange={(selectedOption) =>
                          setWareHouseEntityData({
                            ...wareHouseEntityData,
                            warhouse_type_id: selectedOption.value,
                          })
                        }
                        placeholder={"Select WareHouse Type"}
                      />
                    </div>
                  </div>
                </FormGroup>
              </div>
              <div className="col-md-12" style={{ display: "none" }}>
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Select Entity"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <Select
                        options={entityList}
                        value={entityList.find(
                          (option) =>
                            option.value ===
                            Number(wareHouseEntityData.entity_type_id)
                        )}
                        onChange={(selectedOption) =>
                          setWareHouseEntityData({
                            ...wareHouseEntityData,
                            entity_type_id: selectedOption.value,
                            entity_name: selectedOption.label,
                          })
                        }
                        placeholder={"Select Entity"}
                      />
                    </div>
                    {errors.entity_type_id && (
                      <span className="input-error">
                        {errors.entity_type_id}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my">
                    {t("name")}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <input
                        className="form-control input-search"
                        type="text"
                        value={wareHouseEntityData.warehouse_name}
                        onChange={(e) => {
                          setWareHouseEntityData({
                            ...wareHouseEntityData,
                            warehouse_name: e.target.value,
                          });
                        }}
                        name={`warehouse_name`}
                        maxLength={50}
                        placeholder={t("name")}
                      />
                    </div>
                    {errors.warehouse_name && (
                      <span className="input-error">
                        {errors.warehouse_name}
                      </span>
                    )}
                  </div>
                </FormGroup>
              </div>
              {/* 
              {parentList?.length > 0 && (
                <div className="col-md-12">
                  <FormGroup>
                    <Label className="col-form-label ml-2 Label-my form-label form-label">
                      {"Parent Location"}
                    </Label>
                    <div className="col-xl-12">
                      <div className="input-div">
                        <Select
                          options={parentList}
                          value={parentList.find(
                            (option) =>
                              option.value ===
                              Number(wareHouseEntityData.parent_id)
                          )}
                          onChange={(selectedOption) =>
                            setWareHouseEntityData({
                              ...wareHouseEntityData,
                              parent_id: selectedOption.value,
                            })
                          }
                          placeholder={"Select "}
                        />
                      </div>
                    </div>
                  </FormGroup>
                </div>
              )} */}

              <div className="col-md-12">
                <FormGroup>
                  <Label className="col-form-label ml-2 Label-my form-label form-label">
                    {"Parent Location"}
                  </Label>
                  <div className="col-xl-12">
                    <div className="input-div">
                      <select
                        className="form-select"
                        value={selectedEntityId}
                        onChange={handleSelectChange}
                      >
                        <option>Select</option>
                        {renderOptions(parentList)}
                      </select>
                    </div>
                  </div>
                </FormGroup>
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <button
              type="button"
              className="btn btn-block btn-primary"
              disabled={isModifyButtonLoad}
              onClick={handleCloseModal}
              style={{ width: "100px", marginTop: "10px" }}
            >{t("close")}<i className="bi bi-x-lg"></i>
            </button>
            {!isModifyButtonLoad && (
              <button
                type="submit"
                className="btn btn-block btn-primary"
                style={{ width: "100px", marginTop: "10px" }}
              >{t("submit")}<i className="bi bi-check2"></i>
              </button>
            )}
            {isModifyButtonLoad && (
              <Button
                color="success"
                type={`button`}
                disabled={true}
                className={`btn-square`}
              >
                <i className="fa fa-circle-o-notch fa-spin"></i> {t("loading")}
              </Button>
            )}
          </ModalFooter>
        </Form>
      </Modal>

      <Modal isOpen={modifyBarcodeModal}>
        <ModalHeader>{`Barcode`}</ModalHeader>
        <ModalBody>
          <div ref={qrRef}>
            <div style={{ textAlign: "center" }}>
              <QRCodeCanvas
                value={BarcodeData?.warehouse_full_path || ""}
                size={150} // size of QR code
                level="H" // error correction
                includeMargin={true}
              />
              {BarcodeData?.warehouse_full_path && (
                <p
                  style={{
                    fontSize: "19px",
                    fontWeight: "600",
                    marginTop: "10px",
                  }}
                >
                  {BarcodeData?.warehouse_full_path}
                </p>
              )}
            </div>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            className="btn btn-block btn-primary"
            onClick={handleBarcodeClose}
            style={{ width: "100px", marginTop: "10px" }}
          >{t("close")}<i className="bi bi-x-lg"></i>
          </button>

          <button
            type="button"
            onClick={printQRCode}
            className="btn btn-block btn-primary"
            style={{ width: "100px", marginTop: "10px" }}
          >{t("print")}<i className="bi bi-x-lg"></i>
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default WareHouseMain;
